import React from "react";
import Resultado from "./Resultado";

const TabelaResultado = ({ exibirCodigo = true, resultadosImportacao }) => {
  return (
    <div className="col-12">
      <table
        id="tableImport"
        className="table table-striped table-hover dataTable"
      >
        <thead>
          <tr>
            <th>Linha</th>
            {exibirCodigo ? <th>Identificação</th> : null}
            <th>Status</th>
            <th>Mensagem</th>
          </tr>
        </thead>
        <tbody>
          {resultadosImportacao.map((resultadoImportacao) => (
            <Resultado
              exibirCodigo={exibirCodigo}
              key={resultadoImportacao.linha}
              linha={resultadoImportacao.linha}
              leadCod={`Cliente: ${resultadoImportacao.leadNome} | Parcela: ${resultadoImportacao.parcela}`}
              sucesso={resultadoImportacao.sucesso}
              mensagem={resultadoImportacao.mensagem}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TabelaResultado;
